import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import { InfoIcon } from '@components/icons/svg-icon.tsx';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

type InfoTooltipProps = {
  text: string;
  color?: string;
};

const InfoTooltip: React.FC<InfoTooltipProps> = ({ text, color }) => {
  const { t } = useTranslation();
  return (
    <Tooltip title={t(text)} placement="right-start">
      <Box
        sx={{
          cursor: 'pointer',
          padding: 0,
          marginLeft: '8px',
          display: 'flex',
          alignItems: 'center',
          ...(color
            ? {
                '& svg path': { stroke: color, strokeOpacity: 1 }
              }
            : {
                '&:hover svg path': { stroke: 'var(--primary)' }
              })
        }}
      >
        <InfoIcon className="w-5! h-5! max-lg-xl:w-4.75! max-lg-xl:h-4.75!" />
      </Box>
    </Tooltip>
  );
};

export default InfoTooltip;
